import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} MT84 MALT 0110 0001 2345 MTLC AST0 01S`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: "International Bank Account Number",
      })
    ),
  },
  local: [
    {
      name: FieldName.branchCode,
      label: "Sort code",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 44093`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions",
          message: "Branch code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Numru tal‑kont bankarju",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 9027293051`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [FieldName.iban],
  secondaryBankDetailsField: [FieldName.branchCode, FieldName.accountNumber],
});
